import VoiceMessage from './VoiceMessage';

export default VoiceMessage;
